import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { productAccessorIsPrescriptionProduct } from '../../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { productAccessorIsProductOutOfSale } from '../../../model/productAccessor/productAccessorIsProductOutOfSale'
import { useProductPageContext } from '../../productPageContext'
import { useProductStockStatus } from '../hooks/useProductStockStatus'
import { ProductBuyBoxDeliveryOption } from '../ProductBuyBoxNowDeliveryOption'
import { ProductBuyBoxNowDeliveryOptions } from '../ProductBuyBoxNowDeliveryOptions'

export const ProductBuyBoxDeliveryOptions: FC = () => {
  const { currentVariant } = useProductPageContext()
  const productStockStatus = useProductStockStatus()

  if (productAccessorIsPrescriptionProduct(currentVariant)) {
    return productAccessorIsProductOutOfSale(currentVariant.stock_status) ? (
      <ProductBuyBoxDeliveryOption
        dotColor={productStockStatus.dotColor}
        message={productStockStatus.message}
      />
    ) : (
      <>
        <div className="flex-col items-start">
          <span className="text-s font-medium text-dark-primary-max">
            <FormattedMessage id="general.delivery.rx.erx" />
          </span>
          <ProductBuyBoxDeliveryOption
            additionalInfo={
              <FormattedMessage id="general.delivery.rx.nextDayDescription" />
            }
            dotColor="bg-dark-hover-success"
            message={<FormattedMessage id="general.delivery.rx.nextDay" />}
          />
        </div>
        <div className="flex-col items-start">
          <span className="text-s font-medium text-dark-primary-max">
            <FormattedMessage id="general.delivery.rx.recipe" />
          </span>
          <ProductBuyBoxDeliveryOption
            additionalInfo={
              <FormattedMessage id="general.delivery.rx.freeShipping" />
            }
            dotColor="bg-dark-hover-success"
            message={
              <FormattedMessage id="general.label.product.availableDays" />
            }
          />
        </div>
      </>
    )
  }

  return (
    <div className="my-4">
      <ProductBuyBoxDeliveryOption
        dotColor={productStockStatus.dotColor}
        message={productStockStatus.message}
      />
      <ProductBuyBoxNowDeliveryOptions />
    </div>
  )
}
